import { Box, IconButton, Stack, useTheme } from "@mui/material"
import { DateInput, isMobileView } from "@sis/react-library"
import dayjs from "dayjs"
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';

interface ScheduleActionsDateProps {
    date: Date;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ScheduleActionsDate = ({
    date, onChange
}: ScheduleActionsDateProps) => {

    const theme = useTheme();
    const isMobile = isMobileView();

    const handlePreviousDate = () => {
        handleDateChange(-1);
    }

    const handleNextDate = () => {
        handleDateChange(1);
    }

    const handleDateChange = (addDays: number) => {
        const newDate = dayjs(date).add(addDays, 'day').format("YYYY-MM-DD");
        // allow parameter to be any
        // eslint-disable-next-line
        const changeParam: any = { target: { value: newDate } };
        onChange(changeParam);
    }

    const maxDate = dayjs().add(globalThis.config.max_search_date, "days");
    const dateDiff = maxDate.diff(date, "day");
    const disableNextButton = dateDiff <= 0;

    return (
        <Box sx={{ display: 'flex' }}>
            <Stack
                direction='row'
                sx={{
                    border: `1px solid ${theme.palette.grey[400]}`,
                    borderRadius: '4px',
                    marginTop: '16px',
                    height: '40px',
                    backgroundColor: theme.palette.common.white
                }}
            >
                <Box sx={{ padding: '6px 6px 0 2px' }}>
                    <IconButton
                        id="actions-date-previous"
                        aria-label="previousDate"
                        sx={{ padding: '2px' }}
                        onClick={handlePreviousDate}
                    >
                        <ArrowCircleLeftOutlinedIcon />
                    </IconButton>
                </Box>
                <DateInput
                    id="actions-date"
                    variant="standard"
                    width="120px"
                    sx={{ marginTop: '-9px', height: "30px" }}
                    maxDate={maxDate.toISOString()}
                    value={date}
                    showDaysOutsideCurrentMonth
                    actions={['today']}
                    textFieldProps={{
                        size: 'small',
                        disabled: !isMobile,
                        sx: {
                            "& .MuiSvgIcon-root": {
                                marginTop: '-4px', marginLeft: '-12px', border: '0 !important'
                            },
                            "& .MuiPickersInputBase-root": {
                                marginLeft: '2px',                                
                                border: '0 !important',
                                color: `${theme.palette.common.black} !important`
                            }
                        }
                    }}
                    onChange={onChange}
                />
                {/* <DateInput
                    id="actions-date"
                    variant="standard"
                    width="120px"
                    sx={{ height: "30px" }}
                    maxDate={maxDate.toISOString()}
                    value={date}
                    showDaysOutsideCurrentMonth
                    actions={['today']}
                    textFieldProps={{
                        size: 'small',
                        disabled: !isMobile,                            
                        sx: {
                            border: '0 !important',
                            "& .MuiSvgIcon-root": {
                                marginLeft: '-12px', marginRight: '-2px', border: '0 !important'
                            },
                            "& .MuiPickersInputBase-root": {
                                marginLeft: '-8px', marginRight: '-4px',
                                color: theme.palette.common.black
                            },
                            "& .MuiPickersOutlinedInput-notchedOutline": {
                                border: '0 !important'
                            }                                
                        }
                    }}
                    onChange={onChange}
                /> */}
                <Box sx={{ padding: '6px 2px 0 6px' }}>
                    <IconButton
                        id="actions-date-next"
                        aria-label="nextDate"
                        sx={{ padding: '2px' }}
                        disabled={disableNextButton}
                        onClick={handleNextDate}
                    >
                        <ArrowCircleRightOutlinedIcon />
                    </IconButton>
                </Box>
            </Stack>
        </Box>
    )
}
